<template>
  <v-dialog v-model="navigation.CRMWhatsappContactNoteDialogIsVisible" max-width="60vw">
   <v-card max-width="60vw" style="padding: 15px;">
      <div v-if="loader.selectCRMWhatsappContactNoteFromCRMWhatsappContactNoteDialog" style="width: 100%; text-align: center;">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
      <div v-else>
        <div style="width: 100%; text-align: center; display: flex; align-items: center; gap: 10px;">
          <div style="flex: 1;">
            <h2>{{ navigation.CRMWhatsappContact.CRMWhatsappContactName }}</h2>
            <p>{{ $displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(navigation.CRMWhatsappContact.CRMWhatsappContactPhoneNumber) }}</p>
          </div>
          <v-tooltip :disabled="systemInformationData.tooltipDisabled" location="top" text="Agregar nota al contacto">
            <template v-slot:activator="{ props }">
              <v-icon v-bind="props" @click="openInsertOrUpdateOrDeleteCRMWhatsappContactNoteDialog(null, false)" color="primary" size="x-large" class="hoverableElement" style="cursor: pointer; margin-right: 20px;">mdi-plus-circle-outline</v-icon>
            </template>
          </v-tooltip>
        </div>
        <br>
        <v-card color="border" style="padding: 15px;">
          <v-data-table :headers="display.CRMWhatsappContactNotesHeaders" :items="display.CRMWhatsappContactNotes" :items-per-page="-1" style="max-height: 500px; overflow-y: auto;">
            <template v-slot:item.CRMWhatsappContactNoteID="{ item }">
              <v-tooltip :disabled="systemInformationData.tooltipDisabled" location="top" text="Copiar ID al portapapeles">
                <template v-slot:activator="{ props }">
                  <p v-bind="props" @click="$generalFunctions.default.copyToClipboard(this, 'ID de la nota del contacto', 'o', item.CRMWhatsappContactNoteID)" class="hoverableElement" style="cursor: pointer; user-select: none;"><strong>{{ item.CRMWhatsappContactNoteID }}</strong></p>
                </template>
              </v-tooltip>
            </template>
            <template v-slot:item.CRMWhatsappContactNoteName="{ item }">
              <p>{{ item.CRMWhatsappContactNoteName }}</p>
              <p style="font-size: smaller; color: #9e9e9e;">{{ item.CRMWhatsappContactNoteDescription }}</p>
            </template>
            <template v-slot:item.CRMWhatsappContactNoteContent="{ item }">
              <div style="width: 250px">
                <p style="white-space: pre-wrap;">{{ item.CRMWhatsappContactNoteContent }}</p>
              </div>
            </template>
            <template v-slot:item.CRMAgentName="{ item }">
              <div style="display: flex; align-items: center; gap: 10px;">
                <v-chip :color="item.CRMAgentColor" variant="flat" style="cursor: default; user-select: none;">
                  <div style="display: flex; align-items: center;">
                    <img :src="item.CRMAgentProfilePictureURL" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                    <p :style="{ color: item.CRMAgentFontColor, margin: 0 }">{{ item.CRMAgentName }}</p>
                  </div>
                </v-chip>
                <p style="font-size: smaller; color: #9e9e9e;">a las {{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(item.CRMWhatsappContactNoteUpdateDatetime) }}</p>
              </div>
            </template>
            <template v-slot:item.CRMWhatsappContactNoteAction="{ item }">
              <v-tooltip :disabled="systemInformationData.tooltipDisabled" location="top" text="Editar nota del contacto">
                <template v-slot:activator="{ props }"> 
                  <v-icon v-bind="props" @click="openInsertOrUpdateOrDeleteCRMWhatsappContactNoteDialog(item, false)" color="warning" class="hoverableElement" style="margin-right: 5px;">mdi-pencil</v-icon>
                </template>
              </v-tooltip>
              <v-tooltip :disabled="systemInformationData.tooltipDisabled" location="top" text="Eliminar nota del contacto">
                <template v-slot:activator="{ props }">
                  <v-icon v-bind="props" @click="openInsertOrUpdateOrDeleteCRMWhatsappContactNoteDialog(item, true)" color="error" class="hoverableElement" style="margin-right: 20px;">mdi-delete</v-icon>
                </template>
              </v-tooltip>
              <v-tooltip :disabled="systemInformationData.tooltipDisabled" text="Mover la nota del contacto hacia arriba" location="top">
                <template v-slot:activator="{ props }">
                  <v-icon v-if="item.CRMWhatsappContactNoteIndex > 1" @click="updateCRMWhatsappContactNoteIndex(item, -1)" v-bind="props" class="hoverableElement" style="margin-right: 5px;">mdi-arrow-up-thin-circle-outline</v-icon>
                </template>
              </v-tooltip>
              <v-tooltip :disabled="systemInformationData.tooltipDisabled" text="Mover la nota del contacto hacia abajo" location="top">
                <template v-slot:activator="{ props }">
                  <v-icon v-if="item.CRMWhatsappContactNoteIndex < display.CRMWhatsappContactNotes.length" @click="updateCRMWhatsappContactNoteIndex(item, 1)" class="hoverableElement" v-bind="props">mdi-arrow-down-thin-circle-outline</v-icon>
                </template>
              </v-tooltip>
            </template>
            <template #bottom></template>
          </v-data-table> 
        </v-card>
      </div>
   </v-card>
  </v-dialog>

  <v-dialog v-model="navigation.insertOrUpdateCRMWhatsappContactNoteDialogIsVisible" :max-width="navigation.deleteCRMWhatsappContactNote ? '30vw' : '40vw'" persistent> 
    <v-card :max-width="navigation.deleteCRMWhatsappContactNote ? '30vw' : '40vw'" style="padding: 15px;">
      <div v-if="loader.insertCRMWhatsappContactNote || loader.updateCRMWhatsappContactNote || loader.deleteCRMWhatsappContactNote" style="width: 100%; text-align: center;">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
      <div v-else>
        <div v-if="navigation.deleteCRMWhatsappContactNote" style="text-align: center;">
          <p>¿Está seguro de que desea eliminar la nota <strong>{{ navigation.CRMWhatsappContactNote.CRMWhatsappContactNoteName }}</strong> del contacto?</p>
          <p>Esta acción no se puede deshacer</p>
        </div>
        <div v-else>
          <v-text-field
            ref="CRMWhatsappContactNoteName"
            v-model="input.CRMWhatsappContactNoteName" 
            :append-inner-icon="input.CRMWhatsappContactNoteName ? 'mdi-cancel' : 'mdi-alpha-a-box-outline'"
            @click:append-inner="$generalFunctions.default.blurInput(this, 'CRMWhatsappContactNoteName'); input.CRMWhatsappContactNoteName = null" 
            label="Nombre de la nota del contacto" 
            variant="solo-filled" 
            density="compact"
            autocomplete="off"
          ></v-text-field>
          <v-textarea
            ref="CRMWhatsappContactNoteDescription"
            v-model="input.CRMWhatsappContactNoteDescription" 
            :append-inner-icon="input.CRMWhatsappContactNoteDescription ? 'mdi-cancel' : 'mdi-alpha-b-box-outline'"
            @click:append-inner="$generalFunctions.default.blurInput(this, 'CRMWhatsappContactNoteDescription'); input.CRMWhatsappContactNoteDescription = null" 
            label="Descripción de la nota del contacto (opcional)" 
            variant="solo-filled" 
            rows="2"
            density="compact"
            autocomplete="off"
          ></v-textarea>
          <v-textarea
            ref="CRMWhatsappContactNoteContent"
            v-model="input.CRMWhatsappContactNoteContent" 
            :append-inner-icon="input.CRMWhatsappContactNoteContent ? 'mdi-cancel' : 'mdi-alpha-c-box-outline'"
            @click:append-inner="$generalFunctions.default.blurInput(this, 'CRMWhatsappContactNoteContent'); input.CRMWhatsappContactNoteContent = null" 
            label="Contenido de la nota del contacto"
            rows="3"
            variant="solo-filled" 
            density="compact"
            autocomplete="off"
          ></v-textarea>
        </div>
        <br>
        <v-tooltip :disabled="validateInputForInsertOrUpdateOrDeleteCRMWhatsappContactNoteDialog(false).success" location="top"> 
          <template v-slot:activator="{ props }">
            <div v-bind="props">
              <v-btn 
                @click="navigation.CRMWhatsappContactNote ? (navigation.deleteCRMWhatsappContactNote ? deleteCRMWhatsappContactNote() : updateCRMWhatsappContactNote()) : insertCRMWhatsappContactNote()" 
                :disabled="!validateInputForInsertOrUpdateOrDeleteCRMWhatsappContactNoteDialog(false).success" 
                :color="navigation.deleteCRMWhatsappContactNote ? 'error' : 'success'" 
                dark 
                block 
                height="38" 
                style="margin-bottom: 15px;"
              >
                <h3>{{ navigation.CRMWhatsappContactNote ? (navigation.deleteCRMWhatsappContactNote ? 'ELIMINAR' : 'ACTUALIZAR') : 'AGREGAR' }} NOTA DEL CONTACTO</h3>
                <v-icon style="margin-left: 10px;" dark right>{{ navigation.CRMWhatsappContactNote ? (navigation.deleteCRMWhatsappContactNote ? 'mdi-delete-circle-outline' : 'mdi-update') : 'mdi-plus-circle-outline' }}</v-icon>
              </v-btn>
            </div>
          </template>
          <span style="max-width: 400px; display: block;">{{ validateInputForInsertOrUpdateOrDeleteCRMWhatsappContactNoteDialog(false).result }}</span>
        </v-tooltip>
        <v-btn @click="navigation.insertOrUpdateCRMWhatsappContactNoteDialogIsVisible = false" :color="navigation.deleteCRMWhatsappContactNote ? 'info' : 'error'" dark block height="38">
          <h3>CANCELAR</h3>
          <v-icon style="margin-left:10px;" dark right>mdi-close-circle-outline</v-icon>
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>
  
<style scoped>
</style>

<script>
  import { systemInformation } from '@/utilities/systemInformation';

  export default {
    inject: ['$generalFunctions', '$displayFunctions', '$assets'],
    components: {},
    data: () => 
    ({
      input: 
      {
        CRMWhatsappContactNoteName: null,
        CRMWhatsappContactNoteDescription: null,
        CRMWhatsappContactNoteContent: null
      },
      display: 
      {
        CRMWhatsappContactNotes: [],
        CRMWhatsappContactNotesHeaders:
        [
          {title: 'ID', value: 'CRMWhatsappContactNoteID', sortable: false},
          {title: 'NOMBRE', value: 'CRMWhatsappContactNoteName', sortable: false},
          {title: 'CONTENIDO', value: 'CRMWhatsappContactNoteContent', sortable: false},
          {title: 'ACTUALIZACIÓN', value: 'CRMAgentName', sortable: false},
          {title: null, value: 'CRMWhatsappContactNoteAction', sortable: false}
        ]
      },
      navigation: 
      {
        CRMWhatsappContactNoteDialogIsVisible: false,
        CRMWhatsappContact: null,
        
        insertOrUpdateCRMWhatsappContactNoteDialogIsVisible: false,
        CRMWhatsappContactNote: null,
        deleteCRMWhatsappContactNote: false
      },
      loader: 
      {
        selectCRMWhatsappContactNoteFromCRMWhatsappContactNoteDialog: false
      },
      asset: {},
      systemInformationData: 
      {
        CRMAccountID: null,
        CRMAgentID: null,
        tooltipDisabled: false
      },
      interval: {}
    }),

    watch: {},

    methods:
    {

      validateInputForInsertOrUpdateOrDeleteCRMWhatsappContactNoteDialog(showSystemNotificationDialog){
        const regularExpressionChecker = /\S/;
        if (this.navigation.deleteCRMWhatsappContactNote){
          return {success: true, result: null};
        } else if (this.input.CRMWhatsappContactNoteName == null || !regularExpressionChecker.test(this.input.CRMWhatsappContactNoteName)){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForInsertOrUpdateOrDeleteCRMWhatsappContactNoteDialog_error', 'warning', 'El nombre de la nota del contacto es obligatorio', null, false);
          return {success: false, result: 'El nombre de la nota del contacto es obligatorio'};
        } else if (this.input.CRMWhatsappContactNoteName.length > 100){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForInsertOrUpdateOrDeleteCRMWhatsappContactNoteDialog_error', 'warning', 'El nombre de la nota del contacto no puede exceder los 100 caracteres de longitud', null, false);
          return {success: false, result: 'El nombre de la nota del contacto no puede exceder los 100 caracteres de longitud'};
        } else if (this.input.CRMWhatsappContactNoteDescription != null && this.input.CRMWhatsappContactNoteDescription.length > 65535){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForInsertOrUpdateOrDeleteCRMWhatsappContactNoteDialog_error', 'warning', 'La descripción de la nota del contacto no puede exceder los 65535 caracteres de longitud', null, false);
          return {success: false, result: 'La descripción de la nota del contacto no puede exceder los 65535 caracteres de longitud'};
        } else if (this.input.CRMWhatsappContactNoteContent == null || !regularExpressionChecker.test(this.input.CRMWhatsappContactNoteContent)){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForInsertOrUpdateOrDeleteCRMWhatsappContactNoteDialog_error', 'warning', 'El contenido de la nota del contacto es obligatorio', null, false);
          return {success: false, result: 'El contenido de la nota del contacto es obligatorio'};
        } else if (this.input.CRMWhatsappContactNoteContent.length > 65535){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForInsertOrUpdateOrDeleteCRMWhatsappContactNoteDialog_error', 'warning', 'El contenido de la nota del contacto no puede exceder los 65535 caracteres de longitud', null, false);
          return {success: false, result: 'El contenido de la nota del contacto no puede exceder los 65535 caracteres de longitud'};
        }
        return {success: true, result: null};
      },

      async insertCRMWhatsappContactNote(){
        if (this.validateInputForInsertOrUpdateOrDeleteCRMWhatsappContactNoteDialog(true).success){
          this.loader.insertCRMWhatsappContactNote = true;
          const insertCRMWhatsappContactNoteRequestQuery =
          {
            'localStorage':
            {
              'CRMAccountID': this.systemInformationData.CRMAccountID,
              'CRMAgentID': this.systemInformationData.CRMAgentID
            },
            'CRMWhatsappContactID': this.navigation.CRMWhatsappContact.CRMWhatsappContactID,
            'CRMWhatsappContactNoteName': this.input.CRMWhatsappContactNoteName,
            'CRMWhatsappContactNoteDescription': this.input.CRMWhatsappContactNoteDescription,
            'CRMWhatsappContactNoteContent': this.input.CRMWhatsappContactNoteContent
          };
          const insertCRMWhatsappContactNoteResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContactNote/functions/insertCRMWhatsappContactNote', insertCRMWhatsappContactNoteRequestQuery);
          if (insertCRMWhatsappContactNoteResult.success){
            this.$root.notificationDialog.showSystemNotificationDialog('insertCRMWhatsappContactNote_success', 'success', 'La nota del contacto se ha agregado exitosamente', null, true);
            this.navigation.insertOrUpdateCRMWhatsappContactNoteDialogIsVisible = false;
            this.selectCRMWhatsappContactNoteFromCRMWhatsappContactNoteDialog();
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('insertCRMWhatsappContactNote_error', 'error', 'Ha ocurrido un error inesperado al agregar la nota del contacto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          }
          this.loader.insertCRMWhatsappContactNote = false;  
        }
      },

      async updateCRMWhatsappContactNote(){
        if (this.validateInputForInsertOrUpdateOrDeleteCRMWhatsappContactNoteDialog(true).success){
          this.loader.updateCRMWhatsappContactNote = true;
          const updateCRMWhatsappContactNoteRequestQuery =
          {
            'localStorage':
            {
              'CRMAccountID': this.systemInformationData.CRMAccountID,
              'CRMAgentID': this.systemInformationData.CRMAgentID
            },
            'CRMWhatsappContactNoteID': this.navigation.CRMWhatsappContactNote.CRMWhatsappContactNoteID,
            'CRMWhatsappContactID': this.navigation.CRMWhatsappContact.CRMWhatsappContactID,
            'CRMWhatsappContactNoteName': this.input.CRMWhatsappContactNoteName,
            'CRMWhatsappContactNoteDescription': this.input.CRMWhatsappContactNoteDescription,
            'CRMWhatsappContactNoteContent': this.input.CRMWhatsappContactNoteContent
          };
          const updateCRMWhatsappContactNoteResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContactNote/functions/updateCRMWhatsappContactNote', updateCRMWhatsappContactNoteRequestQuery);
          if (updateCRMWhatsappContactNoteResult.success){
            this.$root.notificationDialog.showSystemNotificationDialog('updateCRMWhatsappContactNote_success', 'success', 'La nota del contacto se ha actualizado exitosamente', null, true);
            this.navigation.insertOrUpdateCRMWhatsappContactNoteDialogIsVisible = false;
            this.selectCRMWhatsappContactNoteFromCRMWhatsappContactNoteDialog();
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('updateCRMWhatsappContactNote_error', 'error', 'Ha ocurrido un error inesperado al actualizar la nota del contacto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          }
          this.loader.updateCRMWhatsappContactNote = false;
        }
      },

      async deleteCRMWhatsappContactNote(){
        this.loader.deleteCRMWhatsappContactNote = true;
        const deleteCRMWhatsappContactNoteRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.systemInformationData.CRMAgentID
          },
          'CRMWhatsappContactNoteID': this.navigation.CRMWhatsappContactNote.CRMWhatsappContactNoteID,
          'CRMWhatsappContactID': this.navigation.CRMWhatsappContact.CRMWhatsappContactID,
          'CRMWhatsappContactNoteIndex': this.navigation.CRMWhatsappContactNote.CRMWhatsappContactNoteIndex
        };
        const deleteCRMWhatsappContactNoteResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContactNote/functions/deleteCRMWhatsappContactNote', deleteCRMWhatsappContactNoteRequestQuery);
        if (deleteCRMWhatsappContactNoteResult.success){
          this.$root.notificationDialog.showSystemNotificationDialog('deleteCRMWhatsappContactNote_success', 'success', 'La nota del contacto se ha eliminado exitosamente', null, true);
          this.navigation.insertOrUpdateCRMWhatsappContactNoteDialogIsVisible = false;
          this.selectCRMWhatsappContactNoteFromCRMWhatsappContactNoteDialog();
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('deleteCRMWhatsappContactNote_error', 'error', 'Ha ocurrido un error inesperado al eliminar la nota del contacto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
        this.loader.deleteCRMWhatsappContactNote = false;
      },

      async updateCRMWhatsappContactNoteIndex(CRMWhatsappContactNote, CRMWhatsappContactNoteIndexMovement){
        const CRMWhatsappContactNoteOldIndex = CRMWhatsappContactNote.CRMWhatsappContactNoteIndex;
        const CRMWhatsappContactNoteNewIndex = CRMWhatsappContactNote.CRMWhatsappContactNoteIndex + CRMWhatsappContactNoteIndexMovement;
        if (CRMWhatsappContactNoteOldIndex != CRMWhatsappContactNoteNewIndex){
          if (CRMWhatsappContactNoteOldIndex > CRMWhatsappContactNoteNewIndex){
            this.display.CRMWhatsappContactNotes.filter(CRMWhatsappContactNote => (CRMWhatsappContactNote.CRMWhatsappContactNoteIndex >= CRMWhatsappContactNoteNewIndex && CRMWhatsappContactNote.CRMWhatsappContactNoteIndex < CRMWhatsappContactNoteOldIndex)).forEach(CRMWhatsappContactNote => {
              CRMWhatsappContactNote.CRMWhatsappContactNoteIndex = CRMWhatsappContactNote.CRMWhatsappContactNoteIndex + 1;
            });
          } else {
            this.display.CRMWhatsappContactNotes.filter(CRMWhatsappContactNote => (CRMWhatsappContactNote.CRMWhatsappContactNoteIndex > CRMWhatsappContactNoteOldIndex && CRMWhatsappContactNote.CRMWhatsappContactNoteIndex <= CRMWhatsappContactNoteNewIndex)).forEach(CRMWhatsappContactNote => {
              CRMWhatsappContactNote.CRMWhatsappContactNoteIndex = CRMWhatsappContactNote.CRMWhatsappContactNoteIndex - 1;
            });
          }
          CRMWhatsappContactNote.CRMWhatsappContactNoteIndex = CRMWhatsappContactNoteNewIndex;
          this.display.CRMWhatsappContactNotes.sort((CRMWhatsappContactNoteA, CRMWhatsappContactNoteB) => {
            return CRMWhatsappContactNoteA.CRMWhatsappContactNoteIndex - CRMWhatsappContactNoteB.CRMWhatsappContactNoteIndex;
          });
          const updateCRMWhatsappContactNoteIndexRequestQuery =
          {
            'localStorage': 
            {
              'CRMAccountID': this.systemInformationData.CRMAccountID,
              'CRMAgentID': this.systemInformationData.CRMAgentID
            },
            'CRMWhatsappContactID': this.navigation.CRMWhatsappContact.CRMWhatsappContactID,
            'CRMWhatsappContactNoteID': CRMWhatsappContactNote.CRMWhatsappContactNoteID,
            'CRMWhatsappContactNoteOldIndex': CRMWhatsappContactNoteOldIndex,
            'CRMWhatsappContactNoteNewIndex': CRMWhatsappContactNoteNewIndex
          };
          const updateCRMWhatsappContactNoteIndexResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContactNote/functions/updateCRMWhatsappContactNoteIndex', updateCRMWhatsappContactNoteIndexRequestQuery);
          if (updateCRMWhatsappContactNoteIndexResult.success == false){
            this.$root.notificationDialog.showSystemNotificationDialog('updateCRMWhatsappContactNoteIndex_error', 'error', 'Ha ocurrido un error inesperado al reordenar la nota del contacto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          }
        }
      },

      async selectCRMWhatsappContactNoteFromCRMWhatsappContactNoteDialog(){
        this.loader.selectCRMWhatsappContactNoteFromCRMWhatsappContactNoteDialog = true;
        const selectCRMWhatsappContactNoteFromCRMWhatsappContactNoteDialogRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          },
          'CRMWhatsappContactID': this.navigation.CRMWhatsappContact.CRMWhatsappContactID
        };
        const selectCRMWhatsappContactNoteFromCRMWhatsappContactNoteDialogResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContactNote/functions/selectCRMWhatsappContactNoteFromCRMWhatsappContactNoteDialog', selectCRMWhatsappContactNoteFromCRMWhatsappContactNoteDialogRequestQuery);
        if (selectCRMWhatsappContactNoteFromCRMWhatsappContactNoteDialogResult.success){
          this.display.CRMWhatsappContactNotes = selectCRMWhatsappContactNoteFromCRMWhatsappContactNoteDialogResult.result;
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMWhatsappContactNoteFromCRMWhatsappContactNoteDialog_error', 'error', 'Ha ocurrido un error inesperado al obtener la información de las notas del contacto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          this.navigation.CRMWhatsappContactNoteDialogIsVisible = false;
        }
        this.loader.selectCRMWhatsappContactNoteFromCRMWhatsappContactNoteDialog = false;
      },

      async getSystemInformation(){
        try {
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMAgentID = systemInformation.getCRMAgentID;
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('CRMWhatsappContactNoteDialog_getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('CRMWhatsappContactNoteDialog_getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
      },

      async openInsertOrUpdateOrDeleteCRMWhatsappContactNoteDialog(CRMWhatsappContactNote, deleteCRMWhatsappContactNote){
        this.navigation.CRMWhatsappContactNote = JSON.parse(JSON.stringify(CRMWhatsappContactNote));
        this.navigation.deleteCRMWhatsappContactNote = deleteCRMWhatsappContactNote;
        this.input.CRMWhatsappContactNoteName = this.navigation.CRMWhatsappContactNote ? this.navigation.CRMWhatsappContactNote.CRMWhatsappContactNoteName : null;
        this.input.CRMWhatsappContactNoteDescription = this.navigation.CRMWhatsappContactNote ? this.navigation.CRMWhatsappContactNote.CRMWhatsappContactNoteDescription : null;
        this.input.CRMWhatsappContactNoteContent = this.navigation.CRMWhatsappContactNote ? this.navigation.CRMWhatsappContactNote.CRMWhatsappContactNoteContent : null;
        this.navigation.insertOrUpdateCRMWhatsappContactNoteDialogIsVisible = true;
      },

      async openCRMWhatsappContactNoteDialog(CRMWhatsappContactNoteDialogRequestQuery){
        this.display.CRMWhatsappContactNotes.length = 0;
        this.loader.selectCRMWhatsappContactNoteFromCRMWhatsappContactNoteDialog = false;
        this.loader.insertCRMWhatsappContactNote = false;
        this.loader.updateCRMWhatsappContactNote = false;
        this.loader.deleteCRMWhatsappContactNote = false;
        await this.getSystemInformation();
        this.navigation.CRMWhatsappContact = JSON.parse(JSON.stringify(CRMWhatsappContactNoteDialogRequestQuery.CRMWhatsappContact));
        this.navigation.CRMWhatsappContactNote = null;
        this.navigation.insertOrUpdateCRMWhatsappContactNoteDialogIsVisible = false;
        this.navigation.CRMWhatsappContactNoteDialogIsVisible = true;
        this.selectCRMWhatsappContactNoteFromCRMWhatsappContactNoteDialog();
      }
    },

    mounted(){}
  }
</script>